import React from 'react';
import Stack from '@mui/material/Stack';
import ButtonBase from '@mui/material/ButtonBase';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import {
    useCurrentTracklog,
    useDebriefApp,
    useMapSettings,
} from 'ff/debrief/hooks';
import SidebarPanel from 'ff/debrief/layouts/SidebarPanel';
import FlightInfo from 'ff/debrief/components/segments/FlightInfo';
import InfoTable from 'ff/debrief/components/infoTable/InfoTable';
import { RouteContext } from 'ff/debrief/router';

const InfoSidebar = () => {
    const { isShareApp } = useDebriefApp();
    const { tracklog, trimmedValues } = useCurrentTracklog();
    const { resetMap } = useMapSettings();
    const { returnLink } = React.useContext(RouteContext);

    if (!tracklog || !trimmedValues) return null;

    const handleBackButtonClick = () => {
        resetMap();
    };

    return (
        <SidebarPanel>
            <Stack py={2} px={0.5} height="100%">
                <FlightInfo
                    {...tracklog}
                    action={
                        !isShareApp && (
                            <ButtonBase
                                component={returnLink}
                                onClick={handleBackButtonClick}
                                sx={{ padding: 1 }}
                            >
                                <ArrowBackIosIcon />
                            </ButtonBase>
                        )
                    }
                />
                <InfoTable />
            </Stack>
        </SidebarPanel>
    );
};

export default InfoSidebar;
